import request from '../utils/request';

// ========== 管理员相关 ==========
export const adminLogin = (data) => request.post('/admin/login', data);
export const getAdminProfile = () => request.get('/admin/profile');
export const updateAdminProfile = (data) => request.put('/admin/profile', data);
export const getAdminList = (params) => request.get('/admin/admins', { params });
export const createAdmin = (data) => request.post('/admin/admins', data);

// ========== 用户管理 ==========
export const getUserList = (params) => request.get('/admin/users', { params });
export const getUser = (id) => request.get(`/admin/users/${id}`);
export const banUser = (id, data) => request.post(`/admin/users/${id}/ban`, data);
export const unbanUser = (id) => request.post(`/admin/users/${id}/unban`);
export const deleteUser = (id) => request.delete(`/admin/users/${id}`);
export const updateUserVIP = (id, data) => request.put(`/admin/users/${id}/vip`, data);
export const updateUserTester = (id, data) => request.put(`/admin/users/${id}/tester`, data);

// ========== 分类管理 ==========
export const getCategoryList = () => request.get('/admin/categories');
export const createCategory = (data) => request.post('/admin/categories', data);
export const updateCategory = (id, data) => request.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => request.delete(`/admin/categories/${id}`);

// ========== 贴纸管理 ==========
export const getStickerList = (params) => request.get('/admin/stickers', { params });
export const getSticker = (id) => request.get(`/admin/stickers/${id}`);
export const createSticker = (data) => request.post('/admin/stickers', data);
export const updateSticker = (id, data) => request.put(`/admin/stickers/${id}`, data);
export const deleteSticker = (id) => request.delete(`/admin/stickers/${id}`);
export const setStickerCategories = (id, data) => request.put(`/admin/stickers/${id}/categories`, data);
export const setStickerKeywords = (id, data) => request.put(`/admin/stickers/${id}/keywords`, data);

// 批量上传贴纸
export const batchUploadStickers = (formData) => {
  return request.post('/admin/stickers/batch', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000, // 2分钟超时
  });
};

// ========== 关键字管理 ==========
export const getKeywordList = (params) => request.get('/admin/keywords', { params });

// ========== 文件上传 ==========
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request.post('/admin/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// ========== 模板管理 ==========
export const getTemplateList = (params) => request.get('/admin/templates', { params });
export const getTemplate = (id) => request.get(`/admin/templates/${id}`);
export const reviewTemplate = (id, data) => request.post(`/admin/templates/${id}/review`, data);
export const offlineTemplate = (id) => request.post(`/admin/templates/${id}/offline`);
export const deleteTemplate = (id) => request.delete(`/admin/templates/${id}`);
export const setTemplateKeywords = (id, data) => request.put(`/admin/templates/${id}/keywords`, data);

